export default "assets/images/home-introduction-178c46e3.svg";